import { DATE_TIME_FORMAT, DATE_TIME_CHECKING_FORMAT } from "@/common/constant";
import moment from "moment";

export interface IQuote {
  quote_id?: number;
  issue_date: string;
  created: string;
  delivery_busyo_name: string;
  delivery_customer_name: string;
}

export class QuoteDTO implements IQuote {
  quote_id?: number;
  issue_date: string;
  created: string;
  delivery_busyo_name: string;
  delivery_customer_name: string;
}

export default class Quote extends QuoteDTO {
  constructor(dto: QuoteDTO) {
    super();
    Object.assign(this, dto);
  }

  get getIssueDate() {
    return moment(this.issue_date).format(DATE_TIME_FORMAT);
  }

  get getCreatedDate() {
    return moment(this.created).format(DATE_TIME_FORMAT);
  }

  get isShowPurchaseButton() {
    const now = moment().format(DATE_TIME_CHECKING_FORMAT);
    const issueDateTime = moment(this.issue_date).format(
      DATE_TIME_CHECKING_FORMAT
    );

    return issueDateTime > now;
  }
}
// Quotation number, issue date, customer name, person in charge
